module.exports = __webpack_public_path__ + "resources/img/logo_samyang.d36d9fd273fff0a2e182c71ff1e71d50.png";